import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { useTealiumEventProperties, useTrackPageView } from '@grandvisionhq/svc-tealium/events';
import Layout from '../../components/Layout/Layout.js';
import { pushReturnsEvent } from '../../data-layer/returns.js';
import { useReturnStorage } from '../../hooks/use-returns-storage.js';

const ConfirmationPage = ()=>{
    const { getLabel  } = useIntl();
    const labels = {
        title: getLabel('returns.page.confirmation.intro'),
        intro: getLabel('returns.page.confirmation.title'),
        alerts: {
            dropOffPeriod: getLabel('returns.page.confirmation.alert.dropOffPeriod')
        },
        button: getLabel('returns.page.confirmation.button')
    };
    const [ReturnStorage, ReturnStorageHandlers] = useReturnStorage();
    const onHandleClick = ()=>{
        pushReturnsEvent({
            interactionType: 'create_return_label'
        });
        ReturnStorageHandlers.remove();
    };
    const { commonEventProperties , getCommonUserProperties  } = useTealiumEventProperties();
    const accountReturnsConfirmationPageView = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        const commonUserProperties = yield getCommonUserProperties();
        if (!commonUserProperties) return;
        return swcHelpers.objectSpread({
            id: 'VirtualPage-View',
            Page_Type: 'Static',
            Page_Section1: 'Account'
        }, commonUserProperties, commonEventProperties);
    }), [
        commonEventProperties,
        getCommonUserProperties
    ]);
    useTrackPageView(accountReturnsConfirmationPageView);
    var ref;
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(Heading, {
        component: "h1",
        variant: "small"
    }, labels.intro), /*#__PURE__*/ React.createElement(Text, null, labels.title), (ReturnStorage === null || ReturnStorage === void 0 ? void 0 : ReturnStorage.returnLabelUrl) ? /*#__PURE__*/ React.createElement(Alert, {
        variant: "info",
        className: "alert-m-default"
    }, labels.alerts.dropOffPeriod) : null, /*#__PURE__*/ React.createElement(Button, {
        caption: labels.button,
        className: "confirmation-page__button",
        href: (ref = ReturnStorage === null || ReturnStorage === void 0 ? void 0 : ReturnStorage.returnLabelUrl) !== null && ref !== void 0 ? ref : '',
        isLoading: false,
        onClick: onHandleClick
    }));
};

export { ConfirmationPage as default };
//# sourceMappingURL=ConfirmationPage.js.map
